import { Component } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

const ALLOWED_CHARACTERS_PATTERN = /^[a-zA-Z0-9\s]*$/

@Component({
  selector: 'hs-update-description-modal',
  templateUrl: './update-description-modal.component.html',
})
export class UpdateDescriptionModalComponent {
  description: string | null = null
  modalTitle: string | null = null
  error = ''
  isValid = true

  constructor(readonly activeModal: NgbActiveModal) {}

  private validateDescription(): boolean {
    if (
      this.description &&
      !ALLOWED_CHARACTERS_PATTERN.test(this.description)
    ) {
      this.error =
        'Description contains invalid characters. Only letters, numbers, and spaces are allowed.'
      this.isValid = false
      return this.isValid
    }
    this.error = ''
    this.isValid = true
    return this.isValid
  }

  validateAndSave() {
    if (!this.validateDescription()) {
      return
    }
    this.activeModal.close(this.description)
  }

  onDescriptionChange() {
    this.validateDescription()
  }
}
